<template>
  <div class="page-wrapper">
    <!-- #region  header -->
    <div class="order-header">
      <div class="d-flex align-center justify-space-between pl-4 pr-2 py-1" style="height: 64px">
        <v-btn @click="prePage">
          <v-icon small class="mr-2">mdi-arrow-left</v-icon>
          <span>返回</span>
        </v-btn>
        <div class="text-h6">小芋頭會員</div>
        <v-btn icon color="black" @click="closePage">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
    <!-- #endregion -->

    <!-- #region body -->
    <!-- 飼料數量 (有漸層背景)-->
    <div class="body-top-bg px-4 pb-0">
      <div class="token-outer pa-4">
        <div class="token-inner">
          <div>
            <v-img :src="tokenIcon" height="55" width="55" contain></v-img>
          </div>
          <div>
            <div>我的{{ beefSummary.tokenTypeName }}</div>
            <div>
              <span class="token-amt">{{ beefSummary.availableQuota }}</span>
              <span class="pl-2">顆</span>
            </div>
          </div>
          <div>
            <v-btn text color="secondary" height="28" class="px-1" @click="goManage">飼料管理</v-btn>
          </div>
        </div>
        <div class="mt-3">使用小芋頭飼料來購買小芋頭平台中的服務或商品</div>
      </div>
    </div>
    <!-- #endregion -->

    <!-- #region (無漸層背景) -->
    <div class="body-mid-bg pt-0">
      <div class="body-mid-inner">
        <!-- 購買選項 -->
        <div class="body-items">
          <div class="d-flex mb-4">
            <v-icon class="mr-3" size="24">mdi-shopping-outline</v-icon>
            <span class="text-h6">
              選擇購買數量
              <span class="red--text">*</span>
            </span>
          </div>
          <v-form ref="form" @submit.prevent>
            <v-radio-group v-model="selectedOption" mandatory class="mt-0" hide-details>
              <v-row>
                <v-col v-for="opt in options" :key="opt.value" cols="12" class="py-2">
                  <!-- 卡片可以整張被點選 -->
                  <div class="selectable-div pa-4" :class="{ 'active-div': isActive(opt) }" @click="selectOption(opt)">
                    <div class="d-flex align-center justify-space-between">
                      <div class="d-flex align-center">
                        <v-radio :value="opt.value" color="secondary" hide-details>
                          <template #label>
                            <span v-if="!opt.isCustom" class="text-subtitle-1 font-weight-medium">
                              <span class="text-h6">
                                {{ opt.price }}
                              </span>
                              顆 {{ opt.productName }}
                            </span>
                            <span v-if="opt.isCustom">自訂數量</span>
                          </template>
                        </v-radio>
                      </div>

                      <!-- 右側價格 -->
                      <div v-if="!opt.isCustom" class="d-flex align-center">
                        <span class="text-subtitle-2">NT$</span>
                        <span class="text-h6 font-weight-medium ml-1">
                          {{ displayPrice(opt) | formatNumber }}
                        </span>
                      </div>
                    </div>
                    <!-- <div class="ml-8">贈品區</div> -->
                    <!-- 自訂價格 -->
                    <v-expand-transition>
                      <div v-if="opt.isCustom && selectedItem.isCustom" class="">
                        <div class="d-flex align-center mt-2 mb-4">
                          <div>
                            <v-img :src="$icons.token1" width="18" height="18"></v-img>
                          </div>
                          <div class="d-flex align-center" style="width: 100%">
                            <v-text-field v-model.number="customAmt.value" :placeholder="customAmt.placeholder" :rules="customAmt.rules" type="number" min="100" outlined height="56" hide-details="auto" class="ml-4" @click.stop />
                            <div class="ml-2" style="min-width: 86px">顆 {{ opt.productName }}</div>
                          </div>
                        </div>
                        <div class="d-flex justify-space-between align-center">
                          <div>應付金額</div>
                          <div class="d-flex align-center">
                            <span class="text-subtitle-2">NT$</span>
                            <span class="text-h6 font-weight-medium ml-1">
                              {{ displayPrice(opt) | formatNumber }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </v-expand-transition>
                  </div>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-form>
        </div>
        <!-- 發票選項 -->
        <!-- <div class="body-items rounded-lg">
          <div class="d-flex mb-4">
            <v-icon class="mr-3" size="24">mdi-receipt-text-outline</v-icon>
            <span class="text-h6"
              >發票選項 <span class="red--text">*</span></span
            >
          </div>
        </div> -->

        <!-- 購買明細 -->
        <div class="body-items rounded-lg">
          <div class="d-flex mb-4">
            <v-icon class="mr-3" size="24">mdi-receipt-text-outline</v-icon>
            <span class="text-h6">購買明細</span>
          </div>
          <div class="mb-5" style="width: 100%">
            <div class="d-flex justify-space-between my-2">
              <div class="text--secondary">購買方式</div>
              <div>單次購買</div>
            </div>
            <v-divider></v-divider>
            <div class="d-flex justify-space-between my-2">
              <div class="text--secondary">購買顆數</div>
              <div>{{ selectedAmt }} 顆 {{ selectedItem.productName }}</div>
            </div>
            <v-divider></v-divider>
            <div class="d-flex justify-space-between my-2">
              <div class="text--secondary">應付金額</div>
              <div class="red--text">
                NT$
                <span class="text-h6">{{ selectedPrice | formatNumber }}</span>
              </div>
            </div>
          </div>
          <v-btn block color="secondary" class="rounded-pill text-body-1 mb-5" height="54" @click="buyToken" :loading="newebPayLoading">去結帳</v-btn>
          <div class="text-center secondary--text">下一步將前往第三方金流服務進行結帳，您的交易資訊將受到保護。</div>
        </div>
        <!-- 注意事項 -->
        <div class="text--secondary">
          <div class="text-body-2 mb-2">購買小芋頭飼料點數注意事項</div>
          <ol>
            <li v-for="(n, i) in notifications" :key="i + 'n'" class="text-caption">
              {{ n }}
            </li>
          </ol>
        </div>
      </div>
    </div>
    <!-- #endregion -->

    <!-- orderFail dialog -->
    <v-dialog v-model="orderFailDialog" max-width="500" persistent>
      <v-card class="text-center pa-6">
        <div class="d-flex">
          <div style="width: 36px"></div>
          <v-spacer></v-spacer>
          <div class="text-h5 font-weight-medium">購買失敗</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="orderFailDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <div class="my-3 d-flex justify-center">
          <v-img :src="orderFailImg" max-width="166" max-height="135" contain></v-img>
        </div>
        <div class="mb-2 text-left" style="font-size: 17px">很抱歉，飼料購買未成功，請再重新嘗試一次，或使用其他付款方式。</div>

        <div class="text-left" style="font-size: 17px">
          若您需要協助，請撥打
          <a href="tel:0800-06-9595">0800-06-9595</a>
          將由專員為您服務
        </div>

        <div class="text-left mt-4">
          <div class="mb-1">聯絡時請提供以訂單資訊，以加快服務作業</div>
          <div>
            訂單編號：
            <span class="font-weight-medium">{{ newebPayResp.oid }}</span>
          </div>
          <div>
            錯誤代碼：
            <span class="font-weight-medium">{{ newebPayResp.status }}</span>
          </div>
        </div>
        <v-btn class="mt-7" color="primary" height="44" @click="orderFailDialog = false">重新購買</v-btn>
      </v-card>
    </v-dialog>

    <!-- #region 用表單送給藍新 -->
    <form v-show="false" id="newebPayOnce" method="post" action="https://ccore.newebpay.com/MPG/mpg_gateway">
      <!-- 設定 hidden 可以隱藏不用給使用者看的資訊 -->
      <input id="MerchantID" type="hidden" name="MerchantID" :value="onceNewebPayParam.merchantID" />
      <input id="TradeInfo" type="hidden" name="TradeInfo" :value="onceNewebPayParam.tradeInfo" />
      <input id="TradeSha" type="hidden" name="TradeSha" :value="onceNewebPayParam.tradeSha" />
      <input id="Version" type="hidden" name="Version" :value="onceNewebPayParam.version" />
      <input type="submit" value="前往付款" />
    </form>
    <!-- #endregion -->
  </div>
</template>

<script>
import { TokenPurchase_GetProductsByTypeId, TokenPurchase_GetTypes, TokenPurchase_GetUserTokenSummary, NewebPay_Once } from "@/apis/api.js";

export default {
  data() {
    return {
      onceNewebPayParam: {
        merchantID: null,
        tradeInfo: null,
        tradeSha: null,
        version: null,
      },
      tokenIcon: require("@/assets/image/member/Dog Food.png"),
      notifications: [
        "使用期限：【小芋頭飼料點數】具有使用期限，請確保在期限內使用完畢。過期的【小芋頭飼料點數】將無法使用，因此建議提前計劃使用時間，避免點數浪費。",
        "無轉讓與退費：一旦購買【小芋頭飼料點數】，請注意點數無法轉讓與退費。請在購買前確認自己真正需要的點數量，以免購買過多或冗余的點數。",
        "購買數量：在購買【小芋頭飼料點數】之前，請慎重考慮所需的數量。根據使用經驗或計劃，合理評估需要的點數量，以免購買過少或過多，造成使用上的不便。",
        "使用時限：一旦開始使用【小芋頭飼料點數】，請注意點數的使用時限。有些服務可能有特定的使用期限，請在有效期內使用點數以確保享受相應的服務。",
        "聯絡客服：如果在購買或使用【小芋頭飼料點數】的過程中遇到問題，請立即聯繫小芋頭客戶服務。我們將能夠提供必要的支援和解答疑問。",
      ],
      selectedOption: null,
      options: [
        // { id: 1, value: 500, productName: "牛肉飼料", price: 500 },
        // { id: 2, value: 1000, productName: "牛肉飼料", price: 1000 },
        // { id: 3, value: 2000, productName: "牛肉飼料", price: 2000 },
        // {
        //   value: "自訂數量",
        //   label: "自訂數量",
        //   custom: true,
        //   unitPrice: 1,
        //   productName: "牛肉飼料",
        // },
      ],
      tokenTypes: [],
      customAmt: {
        label: "",
        placeholder: "請輸入飼料顆數，最低為100顆",
        value: 100,
        rules: [(v) => !!v || "請輸入數量", (v) => /^\d+$/.test(v) || "只能輸入數字", (v) => parseInt(v, 10) >= 100 || "最低 100 顆", (v) => parseInt(v, 10) <= 199999 || "最多 199999 顆"],
        errorMsg: [],
      },

      beefSummary: {
        tokenTypeCode: "BEEF",
        tokenTypeName: "牛肉飼料",
        totalQuota: 0,
        usedQuota: 0,
        availableQuota: 0,
      },
      newebPayLoading: false,
      orderFailDialog: false,
      orderFailImg: require("@/assets/image/member/order-fail.svg"),
      newebPayResp: {
        oid: null,
        status: null,
        amt: null,
      },
    };
  },
  computed: {
    // 拿到被選中的 option 物件
    selectedItem() {
      return this.options.find((o) => o.value === this.selectedOption) || {};
    },
    // 選中的顆數
    selectedAmt() {
      if (this.selectedItem.isCustom) {
        // 自訂時從 customAmt.value 取
        return this.customAmt.value || 0;
      }
      // 套餐時直接就是那個 value（500、1000…）
      return this.selectedItem.value || 0;
    },
    // 選中的總價
    selectedPrice() {
      if (this.selectedItem.isCustom) {
        return this.customAmt.value * this.selectedItem.unitPrice;
      }
      // 固定方案時，price 欄位就是總價
      return this.selectedItem.price || 0;
    },
    // 單一 option 顯示價格
    totalPrice() {
      // 先找到被選的那個 opt
      const opt = this.options.find((o) => o.value === this.selectedOption);
      if (!opt) return 0;

      // 如果是自訂，就用自訂數量 * 單位價格
      if (opt.isCustom) {
        return this.customAmt.value * opt.unitPrice;
      }

      // 否則就是固定方案的 price
      return opt.price;
    },
  },
  filters: {
    // format 數字
    formatNumber(val) {
      return val != null ? val.toLocaleString() : "";
    },
  },
  mounted() {
    const query = this.$route.query;

    // 從 AI平台 /purchase 轉過來
    if (query.from_ai) {
      localStorage.setItem("from_ai", query.from_ai);
    }

    this.newebPayResp.oid = query.oid;
    this.newebPayResp.status = query.status;
    this.newebPayResp.amt = query.amt;

    const status = typeof query.status === "string" ? query.status.trim().toUpperCase() : "";
    if (status && status !== "SUCCESS") {
      this.orderFailDialog = true;
    }

    this.getTpye_api();
    this.getProducts_api(1); // 目前預設1 牛肉飼料
    let email = localStorage.getItem("_signinEmail");
    this.getUserTokenSummary(email);
  },
  methods: {
    /** 飼料管理 */
    goManage() {
      this.$router.push({ name: "Center", query: { tab: "beef" } });
    },
    /** get 產品 */
    getProducts_api(typeId) {
      TokenPurchase_GetProductsByTypeId(typeId)
        .then((res) => {
          const products = res.data.data;
          console.log(products);

          // 將它轉成你前端要的格式
          this.options = products.map((p) => ({
            id: p.id,
            value: p.quotaValue, // or p.price 都可以
            price: p.price,
            productName: p.tokenTypeName,
            isCustom: p.isCustom,
            unitPrice: p.unitPrice,
          }));
        })
        .catch((err) => {
          console.error(err.response);
        })
        .finally();
    },
    // get 產品類型
    getTpye_api() {
      TokenPurchase_GetTypes()
        .then((res) => {
          this.tokenTypes = res.data.data;
        })
        .catch((err) => {
          console.error(err.response);
        })
        .finally();
    },
    // get user 的 總飼料額
    getUserTokenSummary(email) {
      TokenPurchase_GetUserTokenSummary(email)
        .then((res) => {
          const summaries = res.data;
          const beef = summaries.find((s) => s.tokenTypeCode === "BEEF");
          this.beefSummary = beef;
        })
        .catch((err) => {
          console.error(err.response.data.data);
          const defaultValue = err.response.data.data;
          this.beefSummary = defaultValue;
        })
        .finally();
    },
    /**建立訂單， 藍新金流 newwbpay */
    newebPayPost(payload) {
      NewebPay_Once(payload)
        .then((res) => {
          console.log(res.paymentData);
          let resultPayData = res.data.paymentData;
          this.onceNewebPayParam.merchantID = resultPayData.merchantID;
          this.onceNewebPayParam.tradeInfo = resultPayData.tradeInfo;
          this.onceNewebPayParam.tradeSha = resultPayData.tradeSha;
          this.onceNewebPayParam.version = resultPayData.version;
          setTimeout(() => {
            this.goNewebPayOnce();
          }, 10);
        })
        .catch((err) => {
          console.error(err.response.data.message);
          if (err.response.data.message === "重複下單") {
            this.$notify({ content: "商品重複下單，請於1分鐘後再次下單", status: "error" });
          } else {
            this.$notify({ content: "訂單發生錯誤，請聯絡管理員", status: "error" });
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.newebPayLoading = false;
          }, 2000);
        });
    },
    /**POST 藍新參數 */
    goNewebPayOnce() {
      document.getElementById("newebPayOnce").submit();
    },

    /**去結帳 */
    buyToken() {
      this.newebPayLoading = true;
      if (this.selectedItem.isCustom && !this.$refs.form.validate()) {
        this.$notify({ content: "請輸入正確數量", status: "error" });
        this.newebPayLoading = false;
        return; // 驗證沒過就不繼續
      }

      const payload = {
        email: localStorage.getItem("_signinEmail"),
        productId: this.selectedItem.id,
        quantity: this.selectedPrice,
        customQuantity: this.selectedPrice,
        totalAmount: this.selectedAmt,
        product: this.selectedItem.productName,
        paymentMethod: "",
        agreedTerms: true,
      };

      // 範例： axios.post('/api/checkout', payload)…
      console.log("送出資料", payload);

      this.newebPayPost(payload);
    },
    // 這個方法回傳每個卡片右側要顯示的「當前金額」
    displayPrice(opt) {
      if (opt.isCustom) {
        return this.customAmt.value * opt.unitPrice;
      }
      return opt.price * opt.unitPrice;
    },
    // 選中的radio
    isActive(opt) {
      return this.selectedOption === opt.value;
    },
    // 選擇選項
    selectOption(opt) {
      this.selectedOption = opt.value;
      // 如果剛選 custom，要先重置舊的錯誤狀態
      if (opt.isCustom) this.$refs.form.resetValidation();
    },
    // 上一頁
    prePage() {
      let from = this.$route.query.from;
      switch (from) {
        case "ai":
          window.location.replace(process.env.VUE_APP_MAIN_AICHAT_BASE_URL);
          break;

        default:
          window.history.back();
          break;
      }
    },
    // 關閉分頁
    closePage() {
      if (window.opener) {
        window.close();
      } else {
        this.prePage();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  /* 滿整個視窗高度 */
}

.order-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: #fff;
  /* 或你自己的背景色 */
}

.body-top-bg {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 64px;
  background: linear-gradient(96deg, #2962ff 23.27%, #a0f 108.07%);

  .token-outer {
    border-radius: 8px 8px 0px 0px;
    margin-top: 13px;
    border: 0px solid var(--product-color-Component-TaroLine, rgba(0, 0, 0, 0.12));
    background: var(--product-color-TaroWhite, #fff);
    max-width: 732px;
    width: 100%;

    .token-inner {
      border-radius: 4px;
      display: flex;
      padding: 12px 8px 12px 16px;
      align-items: flex-start;
      justify-content: space-between;
      gap: var(--spacing-16, 16px);
      align-self: stretch;
      background: linear-gradient(90deg, #e1f5fe 0%, #effff0 52%, #fffce5 100%);
    }
  }
}

.body-mid-bg {
  flex: 1;
  /* 最關鍵：填滿父容器剩餘空間 */
  display: flex;
  flex-direction: column;
  height: auto;
  background: var(--color-bg-12, #eceff1);

  .body-mid-inner {
    max-width: 732px;
    margin: 0 auto;
  }

  padding-bottom: 40px;
}

.body-items {
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* 垂直置中 */
  width: 100%;
  padding: var(--spacing-6-24, 24px) 16px;
  border-radius: 0 0 8px 8px;
  background: #fff;
  padding: 16px;
  padding-bottom: 24px;
  margin: 0 auto;
  margin-bottom: 24px;
}

.selectable-div {
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background: transparent;
  transition: border-color 0.3s;
  box-shadow: 0px 0px 9.8px 0px rgba(0, 0, 0, 0.05);
}

.selectable-div:hover,
.selectable-div:focus {
  background: transparent;
  /* 不要 hover 灰底 */
}

.active-div {
  border-radius: 8px;
  border-top: 1px solid var(--product-color-, #2979ff);
  border-right: 1px solid var(--product-color-, #2979ff);
  border-bottom: 1px solid var(--product-color-, #2979ff);
  border-left: 4px solid var(--product-color-, #2979ff);
  background: var(--product-color-TaroWhite, #fff);
  box-shadow: 0px 0px 9.8px 0px rgba(0, 0, 0, 0.05);
}
</style>
